module.exports = __webpack_public_path__ + "img/logo.5a739b6c.png";